import { useMemo } from 'react';
import { useGetDutyColumnsForOrderingQuery } from '@/services/product-catalogue';

export interface OrderedDutyColumn {
  id: string;
  name: string;
  displayOrder: number;
}

/**
 * Custom hook to get duty columns ordered by displayOrder
 * Only returns active columns, sorted by their display order
 */
const useOrderedDutyColumns = () => {
  const { data: dutyColumnsData, isLoading, error } = useGetDutyColumnsForOrderingQuery();

  const orderedColumns = useMemo<OrderedDutyColumn[]>(() => {
    if (!dutyColumnsData?.data) {
      return [];
    }

    return dutyColumnsData.data
      .filter(column => column.isActive)
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map(column => ({
        id: column._id,
        name: column.name,
        displayOrder: column.displayOrder,
      }));
  }, [dutyColumnsData]);

  return {
    orderedColumns,
    isLoading,
    error,
  };
};

export default useOrderedDutyColumns; 